export default "__VITE_PUBLIC_ASSET__bd185476__"